import React from 'react';
import {BottomTabHeaderProps} from '@react-navigation/bottom-tabs';

import {AppRoutesNavigatorParamList} from '../../models/navigationTypes';
import {Stack, Tab} from '../navigators';

export enum StoreType {
  GiftCardStore = 'GiftCardStore',
  LiquorStore = 'LiquorStore',
}

export enum TargetStoreType {
  GiftCardStore = StoreType.GiftCardStore,
  LiquorStore = StoreType.LiquorStore,
  All = 'All',
}

export type RouteWithoutTargetStoreType = Omit<RouteSpec, 'targetStoreType'>;

export type RouteSpec = {
  // `keyof AppRoutesNavigatorParamList` instead of `AppRoute` to keep
  // React Navigation typings happy
  name: keyof AppRoutesNavigatorParamList;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any; // FIX
  title?: string;
  icon?: (props: {focused: boolean; size: number; color: string}) => React.ReactNode;
  tabBarLabel?: string | ((props: {focused: boolean; color: string}) => React.ReactNode);
  showInTab: boolean;
  showInDrawer: boolean;
  requiresLogin?: boolean;
  requiresLogout?: boolean;
  params?: object | undefined;
  header?: (props: BottomTabHeaderProps) => React.ReactNode;
  /**
   * DIS-1127: When true, React Navigation positions the header absolutely
   * (position: 'absolute', top: 0) so it contributes 0 to the flex layout.
   * Required for scroll-collapse screens to avoid a Yoga layout feedback
   * loop that causes Android scroll flicker at the header collapse trigger
   * point. The consuming screen MUST compensate with
   * `paddingTop: useHeaderHeight()` on its scroll content container.
   * See frontend/docs/GOTCHAS.md #24 and the plan at
   * frontend/docs/plans/2026-04-11-dis-1127-header-layout-fix.md.
   */
  headerTransparent?: boolean;
  initialParams?: AppRoutesNavigatorParamList[keyof AppRoutesNavigatorParamList];
  targetStoreType: TargetStoreType;
  drawerSortOrder?: number;
  listeners?:
    | React.ComponentProps<typeof Tab.Screen>['listeners']
    | React.ComponentProps<typeof Stack.Screen>['listeners'];
  // React Navigation v7: animation option replaces animationEnabled
  animation?:
    | 'default'
    | 'none'
    | 'slide_from_left'
    | 'slide_from_right'
    | 'slide_from_bottom'
    | 'fade'
    | 'fade_from_bottom'
    | 'flip'
    | 'simple_push'
    | 'ios'
    | 'ios_from_left'
    | 'ios_from_right';
};
